import { Link } from "react-router-dom";
import type { Comic } from "@/mocks/comics";

interface ComicCardProps {
  comic: Comic;
  rank?: number;
}

export default function ComicCard({ comic, rank }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block overflow-hidden rounded-xl border border-background-200/80 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={comic.cover}
          alt={`${comic.title}漫画封面`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span
          className={`absolute left-2 top-2 rounded-full px-2.5 py-0.5 text-xs font-medium text-background-50 ${
            comic.status === "连载中" ? "bg-accent-500" : "bg-primary-600"
          }`}
        >
          {comic.status}
        </span>
        {rank !== undefined && (
          <span className="absolute left-2 top-2 flex h-7 w-7 items-center justify-center rounded-lg bg-background-950/70 font-heading text-lg text-accent-400">
            {rank}
          </span>
        )}
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-bold text-foreground-950">
          {comic.title}
        </h3>
        <div className="mt-1 flex items-center justify-between text-xs text-foreground-600">
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500"></i>
            {comic.rating.toFixed(1)}
          </span>
          <span>{comic.category}</span>
        </div>
        <p className="mt-1 truncate text-xs text-foreground-500">
          更新至:{comic.chapters[comic.chapters.length - 1]}
        </p>
      </div>
    </Link>
  );
}